import React from 'react'
import Package from './Package'

export default function PackagesContainer({}) {
    return (
        <div className="container">
            <div className="columns multiline">
                <Package/>
                <Package/>
                <Package/>

            </div>
        </div>
    );
}
